import { I18n } from "@lingui/core";

/**
 * 曜日番号（0-6）から曜日名を取得する
 *
 * @param i18n - Linguiのi18nインスタンス
 * @param dayOfWeek - 曜日番号（0: 日曜日, 1: 月曜日, ..., 6: 土曜日）
 * @param format - 曜日のフォーマット（"short": 月火水..., "long": 月曜日火曜日...）
 * @returns 曜日名
 */
export function getWeekdayName(
  i18n: I18n,
  dayOfWeek: number,
  format: "short" | "long" = "long",
): string {
  // 曜日番号を日付に変換（UTC 2024年1月7日は日曜日）
  // getUTCDay()が0を返す日付を基準にして、曜日番号分だけ日数を追加
  const baseDate = new Date(Date.UTC(2024, 0, 7));
  const targetDate = new Date(baseDate);
  targetDate.setUTCDate(baseDate.getUTCDate() + dayOfWeek);

  if (format === "short") {
    // 短い形式: 月、火、水...
    return i18n.date(targetDate, { weekday: "short" });
  } else {
    // 長い形式: 月曜日、火曜日、水曜日...
    return i18n.date(targetDate, { weekday: "long" });
  }
}

/**
 * 曜日番号の配列から曜日名の配列を取得する
 *
 * @param i18n - Linguiのi18nインスタンス
 * @param dayOfWeeks - 曜日番号の配列
 * @param format - 曜日のフォーマット（"short": 月火水..., "long": 月曜日火曜日...）
 * @returns 曜日名の配列
 */
export function getWeekdayNames(
  i18n: I18n,
  dayOfWeeks: number[],
  format: "short" | "long" = "long",
): string[] {
  return dayOfWeeks.map((day) => getWeekdayName(i18n, day, format));
}
